import { clientProductCode } from "../config/config";
import { functions } from '../firebase/Firebase';

export const ArticleActionTypes = {
    GetArticles: 'GetArticles',
    GetArticlesDone: 'GetArticlesDone',
    GetArticle: 'GetArticle',
    GetArticleDone: 'GetArticleDone',
};

function getArticlesFunction() {
    return functions.httpsCallable('neofelisGetArticles');
}

export const getArticles = (lastArticleId) => {
    return async (dispatch, getState) => {
        try {
            let articleState = getState().articleState;
            let getArticlesCompletedInState = articleState.getArticlesCompleted;
            if (getArticlesCompletedInState === false) {
                return;
            }

            dispatch({
                type: ArticleActionTypes.GetArticles,
            });

            const callable = getArticlesFunction();
            const data = {
                clientProductCode: clientProductCode,
                lastArticleId: lastArticleId,
            };

            const result = await callable(data);

            const jsonArticles = result.data.articles;
            const articles = [];

            for (let i = 0; i < jsonArticles.length; i++) {
                const jsonArticle = jsonArticles[i];
                const article = jsonArticle;

                articles.push(article);
            }

            dispatch({
                type: ArticleActionTypes.GetArticlesDone,
                articles: articles,
            });
        } catch (error) {
            dispatch({
                type: ArticleActionTypes.GetArticlesDone,
                error: error,
            });
        }
    };
};

function getArticleFunction() {
    return functions.httpsCallable('neofelisGetArticle');
}

export const getArticle = (articleId) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: ArticleActionTypes.GetArticle,
            });

            const callable = getArticleFunction();
            const data = {
                clientProductCode: clientProductCode,
                articleId: articleId,
            };

            const result = await callable(data);
            const article = result.data.article;

            dispatch({
                type: ArticleActionTypes.GetArticleDone,
                article: article,
            });
        } catch (error) {
            dispatch({
                type: ArticleActionTypes.GetArticleDone,
                error: error,
            });
        }
    };
};
